module.exports = __webpack_public_path__ + "static/SanAntonio-82299f93f86891ed39c462943fa12c4b.jpg";